<template>
  <panel title="Komentarz dotyczący edycji dokumentu">
    <w-textarea class="form-group" :model="model" />
  </panel>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

import Panel from '@/components/panel/Panel.vue';

// @vuese
// Formularz komentarza dokumentu
export default {
  components: { ...components, Panel },
  props: {
    // schema komentarza
    model: { type: Object, required: true }
  }
};
</script>
